<template>
  <div>
    <NavBar />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"width="412.996px" height="412.996px" viewBox="0 0 412.996 412.996" style="enable-background:new 0 0 412.996 412.996;"xml:space="preserve"> <path d="M392.996,28.338H20c-11.047,0-20,8.954-20,20v234c0,11.046,8.953,20,20,20h139.498v45.32h-54.283 c-10.201,0-18.5,8.299-18.5,18.5s8.299,18.5,18.5,18.5h202.566c10.201,0,18.5-8.299,18.5-18.5s-8.299-18.5-18.5-18.5h-54.283 v-45.32h139.498c11.047,0,20-8.954,20-20v-234C412.996,37.292,404.043,28.338,392.996,28.338z M382.996,272.338H30v-214h352.996 V272.338z"/> <path d="M94.591,176.637l63.084,29.336c1.631,0.755,3.367,1.138,5.162,1.138c2.338,0,4.616-0.664,6.597-1.924 c3.548-2.267,5.666-6.13,5.666-10.335v-0.322c0-4.751-2.785-9.115-7.096-11.119l-39.455-18.33l39.456-18.334 c4.31-2.004,7.095-6.369,7.095-11.118v-0.319c0-4.211-2.119-8.074-5.665-10.334c-1.962-1.254-4.247-1.916-6.606-1.916 c-1.778,0-3.563,0.391-5.16,1.133L94.59,153.525c-4.308,2.005-7.091,6.369-7.091,11.117v0.878 C87.498,170.262,90.28,174.625,94.591,176.637z"/> <path d="M175.662,236.389c2.301,3.149,6.002,5.029,9.901,5.029h0.315c5.352,0,10.042-3.426,11.672-8.516l41.557-128.76 c1.192-3.717,0.53-7.818-1.771-10.974c-2.301-3.149-6.002-5.03-9.901-5.03h-0.314c-5.354,0-10.048,3.426-11.679,8.516 L173.88,225.425C172.698,229.145,173.364,233.242,175.662,236.389z"/> <path d="M237.896,135.628c0,4.746,2.782,9.11,7.095,11.122l39.455,18.33l-39.455,18.33c-4.311,2.004-7.096,6.368-7.096,11.119 v0.322c0,4.205,2.117,8.068,5.669,10.336c1.974,1.258,4.254,1.923,6.595,1.923c1.792,0,3.527-0.383,5.169-1.142l63.081-29.335 c4.307-2.009,7.089-6.372,7.089-11.115v-0.878c0-4.748-2.783-9.112-7.093-11.117l-63.08-29.334 c-1.591-0.739-3.373-1.131-5.152-1.131c-2.358,0-4.644,0.662-6.604,1.912c-3.554,2.264-5.673,6.127-5.673,10.338V135.628 L237.896,135.628z"/> </svg>
            Páginas
          </h1>
          <ul class="tabs">
            <li>
              <router-link to="/paginas">Paginas</router-link>
            </li>
            <li class="tab-active">
              <router-link :to="this.item._id || ''">Página: {{ this.item.titulo }}</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <div class="form-single">
                <div class="row">
                  <div class="col-1-2">
                    <div class="form-group">
                      <label for="">Título</label>
                      <input type="text" class="form-control" v-model="item.titulo"  @keyup="changeTitulo()">
                    </div>
                  </div>
                </div>
              </div>
              <button class="button button-primary " v-on:click="modeCode=!modeCode" >Modo <span v-show="!modeCode">Código</span> <span v-show="modeCode">Editor</span> </button>
              <div class="row"  style="margin-bottom: 80px; margin-top: 20px" v-if="modeCode">
                <textarea style='width: 100%; height: 400px' v-model="item.conteudo[0].corpo"></textarea>
              </div>
              <div class="row" style="margin-bottom: 80px;" v-if="!modeCode">
                <div class="pagebox" @keyup="onKeyUp" v-for="(i, index) in item.conteudo" v-bind:key="index">
                  <span class="pagebox-up" v-show="index !== 0" v-on:click="invert(index - 1)">
                    <svg style="fill:#9b9c9a; width: 24px;height: 24px;" x="0px" y="0px" viewBox="0 0 444.819 444.819" > <path d="M433.968,278.657L248.387,92.79c-7.419-7.044-16.08-10.566-25.977-10.566c-10.088,0-18.652,3.521-25.697,10.566 L10.848,278.657C3.615,285.887,0,294.549,0,304.637c0,10.28,3.619,18.843,10.848,25.693l21.411,21.413 c6.854,7.23,15.42,10.852,25.697,10.852c10.278,0,18.842-3.621,25.697-10.852L222.41,213.271L361.168,351.74 c6.848,7.228,15.413,10.852,25.7,10.852c10.082,0,18.747-3.624,25.975-10.852l21.409-21.412 c7.043-7.043,10.567-15.608,10.567-25.693C444.819,294.545,441.205,285.884,433.968,278.657z"/> </svg>
                  </span>
                  <span class="pagebox-down" v-show="index !== item.conteudo.length - 1"  v-on:click="invert(index)">
                    <svg style="fill:#9b9c9a; width: 24px;height: 24px;" x="0px" y="0px" viewBox="0 0 444.819 444.819" > <path d="M434.252,114.203l-21.409-21.416c-7.419-7.04-16.084-10.561-25.975-10.561c-10.095,0-18.657,3.521-25.7,10.561 L222.41,231.549L83.653,92.791c-7.042-7.04-15.606-10.561-25.697-10.561c-9.896,0-18.559,3.521-25.979,10.561l-21.128,21.416 C3.615,121.436,0,130.099,0,140.188c0,10.277,3.619,18.842,10.848,25.693l185.864,185.865c6.855,7.23,15.416,10.848,25.697,10.848 c10.088,0,18.75-3.617,25.977-10.848l185.865-185.865c7.043-7.044,10.567-15.608,10.567-25.693 C444.819,130.287,441.295,121.629,434.252,114.203z"/> </svg>
                  </span>
                  <span v-on:click="remConteudo(index)" class="pagebox-remove"><svg viewBox="0 0 21.9 21.9"><path d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z"/></svg></span>
                  <!-- txt -->
                  <div class="pagebox-txt" v-if="i.tipo === 'txt'">
                    <vue-editor v-bind:id="'editor' + index" :editorToolbar="customToolbar" v-model="i.corpo"></vue-editor>
                  </div>
                  <!-- img -->
                  <div v-else-if="i.tipo === 'img'">
                    <label class="button button-success button-lg" v-if="i.corpo === ''">
                      <svg style="float: left; margin-right: 12px; width: 18px; height: 18px; fill: #fff;" x="0px" y="0px" viewBox="0 0 315.58 315.58"> <g> <path d="M310.58,33.331H5c-2.761,0-5,2.238-5,5v238.918c0,2.762,2.239,5,5,5h305.58c2.763,0,5-2.238,5-5V38.331 C315.58,35.569,313.343,33.331,310.58,33.331z M285.58,242.386l-68.766-71.214c-0.76-0.785-2.003-0.836-2.823-0.114l-47.695,41.979 l-60.962-75.061c-0.396-0.49-0.975-0.77-1.63-0.756c-0.631,0.013-1.22,0.316-1.597,0.822L30,234.797V63.331h255.58V242.386z"/> <path d="M210.059,135.555c13.538,0,24.529-10.982,24.529-24.531c0-13.545-10.991-24.533-24.529-24.533 c-13.549,0-24.528,10.988-24.528,24.533C185.531,124.572,196.511,135.555,210.059,135.555z"/> </g> </svg>
                      Selecione a Imagem
                      <input type="file" name="img" style="display: none;" accept="image/jpg, image/jpeg, image/png, image/webp" @change="handleUpload(index)">
                    </label>
                    <img :src="getImage(i.corpo)" v-else/>
                  </div>
                  <!-- pdf -->
                  <div v-else-if="i.tipo === 'pdf'">
                    <label class="button button-success" v-if="i.corpo.pdf === ''">
                      <svg width="32px" height="32px" x="0px" y="0px" viewBox="0 0 56 56"> <g> <path style="fill:#E9E9E0;" d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074   c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"/> <polygon style="fill:#D9D7CA;" points="37.5,0.151 37.5,12 49.349,12  "/> <path style="fill:#CC4B4C;" d="M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326   c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75   c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172   c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562   c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16   c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822   c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198   c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z    M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415   c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174   c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z    M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"/> <path style="fill:#CC4B4C;" d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"/> <g> <path style="fill:#FFFFFF;" d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205    c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306    c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656    s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103    c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032    c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492    c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"/> <path style="fill:#FFFFFF;" d="M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937    s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035    c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z     M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244    c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"/> <path style="fill:#FFFFFF;" d="M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"/> </g> </g> </svg>
                      <input type="file" name="img" style="display: none;" accept="application/pdf" @change="handleUploadPDF(index)" />
                    </label>
                    <div class="pagebox__pdfs" v-else>
                      <div class="pagebox__pdfs-img">
                        <svg width="32px" height="32px" x="0px" y="0px" viewBox="0 0 56 56"> <g> <path style="fill:#E9E9E0;" d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074   c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"/> <polygon style="fill:#D9D7CA;" points="37.5,0.151 37.5,12 49.349,12  "/> <path style="fill:#CC4B4C;" d="M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326   c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75   c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172   c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562   c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16   c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822   c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198   c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z    M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415   c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174   c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z    M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"/> <path style="fill:#CC4B4C;" d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"/> <g> <path style="fill:#FFFFFF;" d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205    c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306    c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656    s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103    c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032    c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492    c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"/> <path style="fill:#FFFFFF;" d="M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937    s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035    c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z     M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244    c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"/> <path style="fill:#FFFFFF;" d="M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"/> </g> </g> </svg>
                        <img :src="getImage(i.corpo.img)">
                      </div>
                      <div class="pagebox__pdfs-opt">
                        <input type="text" v-model="i.corpo.descricao" />
                        <div class="pagebox__pdfs-opt-checkboxes">
                          <label :for="i.corpo.img">
                            <input type="checkbox" v-model="i.corpo.showImage" :id="i.corpo.img" @change="onKeyUp">
                            Mostrar Imagem
                          </label>
                          <label :for="i.corpo.pdf">
                            <input type="checkbox" v-model="i.corpo.showDescr" :id="i.corpo.pdf" @change="onKeyUp">
                            Mostrar Descrição
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- gal -->
                  <div v-else-if="i.tipo === 'gal'">
                    <div class="row" style="margin-bottom: 18px;">
                      <label class="button button-success">
                        <svg style="float: left; margin-right: 12px; width: 18px; height: 18px; fill: #fff;" x="0px" y="0px" viewBox="0 0 315.58 315.58"> <g> <path d="M310.58,33.331H5c-2.761,0-5,2.238-5,5v238.918c0,2.762,2.239,5,5,5h305.58c2.763,0,5-2.238,5-5V38.331 C315.58,35.569,313.343,33.331,310.58,33.331z M285.58,242.386l-68.766-71.214c-0.76-0.785-2.003-0.836-2.823-0.114l-47.695,41.979 l-60.962-75.061c-0.396-0.49-0.975-0.77-1.63-0.756c-0.631,0.013-1.22,0.316-1.597,0.822L30,234.797V63.331h255.58V242.386z"/> <path d="M210.059,135.555c13.538,0,24.529-10.982,24.529-24.531c0-13.545-10.991-24.533-24.529-24.533 c-13.549,0-24.528,10.988-24.528,24.533C185.531,124.572,196.511,135.555,210.059,135.555z"/> </g> </svg>
                        Selecione a Imagem
                        <input type="file" name="img" style="display: none;" accept="image/jpg, image/jpeg, image/png, image/webp" @change="handleUploadGallery(index)">
                      </label>
                    </div>
                    <div class="row">
                      <div class="col-1-3" v-for="(x, indexImg) in i.corpo">
                        <div class="thumbnail">
                          <div class="LogoimgBox">
                            <img :src="getImage(x)" />
                          </div>
                          <div class="caption">
                            <div class="caption__actions">
                              <button v-on:click="removeImgGallery(index, indexImg)" class="button button-sm button-error">Remover</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="pageboxadd">
                <span v-on:click="addConteudo('txt')" class="txt"><svg style="width: 12px; height: 12px; fill: #fff;" x="0px" y="0px" viewBox="0 0 42 42"> <path d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"/> </svg>Texto</span>
                <span v-on:click="addConteudo('img')" class="img"><svg style="width: 12px; height: 12px; fill: #fff;" x="0px" y="0px" viewBox="0 0 42 42"> <path d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"/> </svg> Imagem</span>
                <span v-on:click="addConteudo('gal')" class="gal"><svg style="width: 12px; height: 12px; fill: #fff;" x="0px" y="0px" viewBox="0 0 42 42"> <path d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"/> </svg> Galeria</span>
                <span v-on:click="addConteudo('pdf')" class="pdf"><svg style="width: 12px; height: 12px; fill: #fff;" x="0px" y="0px" viewBox="0 0 42 42"> <path d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"/> </svg> PDF</span>
              </div>

              <div class="pageboxsave" v-show="shouldSave">
                <button class="button button-success button-lg" v-on:click="save()">Salvar Alterações</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </SideBar>
    </div>
  </div>
</template>

<script>
import { get, post, put, del, uploadImage } from '@/helpers/apiRequest'
import { customToolbar, getImage } from '@/helpers/utils'
const url = '/pagina'
const tipoDeCorpo = (tipo) => {
  if (tipo === 'gal') {
    return []
  }
  if (tipo === 'pdf') {
    return {
      descricao: 'Novo PDF',
      showImage: 0,
      showDescr: 0,
      img: '',
      pdf: ''
    }
  }
  return ''
}
/*
1) [   ] Dimensoes dinamicas
2) [ x ] Salvar os textos
3) [ x ] Reordenar
*/
export default {
  name: 'paginas',
  props: ['id'],
  data () {
    return {
      customToolbar: customToolbar(),
      loading: false,
      shouldSave: false,
      item: {
        titulo: '',
        conteudo: []
      },
      modeCode: false
    }
  },
  methods: {
    getImage: getImage,
    invert (index) {
      let ini = this.item.conteudo.slice(0, index)
      let end = this.item.conteudo.slice(index + 2)
      let a = this.item.conteudo[index] || []
      let b = this.item.conteudo[index + 1] || []
      this.item.conteudo = [].concat(ini, b, a, end)
      this.shouldSave = true
    },
    changeTitulo () {
      this.shouldSave = true
    },
    onKeyUp () {
      this.shouldSave = true
    },
    save (withoutAlert) {
      this.loading = true
      put(`${url}/${this.item._id}`, this.item)
        .then(json => {
          this.loading = false
          this.shouldSave = false
          if (withoutAlert) {
            return
          }
          this.$swal({ title: 'Alterado com Sucesso!', type: 'success'})
        })
        .catch(err => console.log('err', err))
    },
    addConteudo (tipo) {
      this.item.conteudo.push({
        tipo,
        corpo: tipoDeCorpo(tipo)
      })
      this.shouldSave = true;
    },
    remConteudo (index) {
      this.item.conteudo = this.item.conteudo.filter((_, k) => +k !== +index)
      this.shouldSave = true
    },
    handleUpload (index) {
      event.preventDefault()
      const settings = {
        el: event.target,
        str: `/nested/paginas/conteudo/corpo/${this.item._id}/${index}`,
        dim: '480x360'
      }
      this.loading = true
      uploadImage(settings)
        .then(({ filename }) => {
          this.item.conteudo = this.item.conteudo.map((i, k) => {
            if (+index === +k) {
              i.tipo = 'img',
              i.corpo = filename
            }
            return i
          })
          this.loading = false
          this.shouldSave = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    removeImg (index, cb) {
      this.loading = true
      del(`/upload/nested/paginas/conteudo/corpo/${this.item._id}/${index}`)
        .then(json => {
          this.item.conteudo = this.item.conteudo.map((i, k) => {
            if (+index === +k) {
              i.corpo = ''
            }
            return i
          })
          this.loading = false
          cb()
        })
    },
    handleUploadGallery (index) {
      event.preventDefault()
      const settings = {
        el: event.target,
        str: `/paginas/conteudo.${index}.corpo/${this.item._id}`,
        dim: '480x360'
      }
      this.loading = true
      uploadImage(settings)
        .then(({ filename }) => {
          this.item.conteudo = this.item.conteudo.map((i, k) => {
            if (+index === +k) {
              i.tipo = 'gal';
              i.corpo.push(filename)
            }
            return i
          })
          this.loading = false
          this.shouldSave = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    removeImgGallery (index, indexImg) {
      this.loading = true
      del(`/upload/paginas/conteudo.${index}.corpo/${this.item._id}/${indexImg}`)
        .then(json => {
          this.item.conteudo = this.item.conteudo.map((i, k) => {
            if (+index === +k) {
              i.corpo = i.corpo.filter((_, kk) => +kk !== indexImg)
            }
            return i
          })
          this.loading = false
        })
    },
    handleUploadPDF (index) {
      event.preventDefault()
      let formData = new FormData()
      formData.append('img', event.target.files[0], event.target.files[0].name)
      this.loading = true
      post(`/paginas/upload-pdf/${this.item._id}/${index}`, formData, { isFile: true })
        .then(json => {
          const { img, pdf } = json
          this.item.conteudo = this.item.conteudo.map((i, k) => {
            if (+index === +k) {
              i.tipo = 'pdf';
              i.corpo = Object.assign({}, i.corpo, {
                img, pdf
              })
            }
            return i
          })
          this.loading = false
          this.shouldSave = true
        })
        .catch(err => console.log(err))
    }
  },
  beforeMount () {
    this.loading = true
    get(`${url}/${this.$route.params.id}`)
      .then(json => {
        this.loading = false
        this.item = json
      })
      .catch(err => console.log('err', err))
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Paginas/PaginaSingle.vue